import { themeConWeb } from '@app/util/modernThemeConweb'
import { Box, Chip, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CheckCircle } from '@material-ui/icons'
import React from 'react'
import styled from 'styled-components'

import EditSavedLocationForm from './EditSavedLocationForm'
import SavedLocationActions from './SavedLocationActions'

const useStyles = makeStyles(theme => ({
  ListItem: {
    alignItems: 'flex-start',
  },
}))

const SavedLocationListItem = ({
  formattedSavedLocations,
  handleDeleteClick,
  handleEditClick,
  isDefault,
  isEditing,
  isUpdatingSavedLocation,
  location,
  setSavedLocationForEdit,
  updateSavedLocationError,
  updateUserSavedLocationStart,
}) => {
  const classes = useStyles()
  const PrimaryActions = () => (
    <SavedLocationActions
      handleDeleteClick={handleDeleteClick}
      handleEditClick={handleEditClick}
      numLocations={formattedSavedLocations.length}
    />
  )

  return (
    <StyledListItem className={classes.ListItem} isDefault={isDefault}>
      {isEditing ? (
        <EditSavedLocationForm
          isEditing={isEditing}
          isUpdatingSavedLocation={isUpdatingSavedLocation}
          location={location}
          primaryActions={PrimaryActions}
          setSavedLocationForEdit={setSavedLocationForEdit}
          updateSavedLocationError={updateSavedLocationError}
          updateUserSavedLocationStart={updateUserSavedLocationStart}
        />
      ) : (
        <>
          <ListItemText
            primary={
              <>
                <Box display="inline-block" marginRight={2}>
                  {location.name || location.deliveryLocationName}
                </Box>
                {isDefault && (
                  <Chip color="secondary" icon={<CheckCircle />} label="Active" size="small" />
                )}
              </>
            }
            secondary={
              <>
                {location.street}
                <br />
                {location.deliveryInstructions}
              </>
            }
          />
          <PrimaryActions />
        </>
      )}
    </StyledListItem>
  )
}

// It doesn't like an unknown prop being passed to an external component (Material ListItem)
// So we exclude that
const StyledListItem = styled(({ isDefault, ...rest }) => <ListItem {...rest} />)`
  display: flex;
  flex-direction: column;
  border: ${({ isDefault }) =>
    isDefault ? `solid 2px ${themeConWeb.color.brandPrimary}` : 'none'};
  border-radius: ${themeConWeb.baseUnit};
  box-shadow: 0 0 ${themeConWeb.baseUnit} 0 rgba(0, 0, 0, 0.25);
  margin-bottom: calc(${themeConWeb.baseUnit} * 4);
`

export default SavedLocationListItem
